import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Title',
    defaultMessage: 'Add Gross Rent Limits',
  },
  editTitle: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.EditTitle',
    defaultMessage: 'Edit Gross Rent Limits',
  },
  stepNewGrossRentLimits: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Step.NewGrossRentLimits',
    defaultMessage: 'New Gross Rent Limits',
  },
  stepConfirmation: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Step.Confirmation',
    defaultMessage: 'Confirmation',
  },
  cancel: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Cancel',
    defaultMessage: 'Cancel',
  },
  back: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Back',
    defaultMessage: 'Back',
  },
  next: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Next',
    defaultMessage: 'Next',
  },
  confirm: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Confirm',
    defaultMessage: 'Confirm',
  },
  effectiveDate: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.EffectiveDate',
    defaultMessage: 'Effective Date',
  },
  anticipatedVoucherMonth: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.AnticipatedVoucherMonth',
    defaultMessage: 'Anticipated Voucher Month',
  },
  floorPlan: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.FloorPlan',
    defaultMessage: 'Floor Plan',
  },
  bedsBath: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.BedsBath',
    defaultMessage: 'Beds / Bath',
  },
  currentGrossRent: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.CurrentGrossRent',
    defaultMessage: 'Current Gross Rent',
  },
  newGrossRent: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.NewGrossRent',
    defaultMessage: 'New Gross Rent',
  },
  currentUtilityAllowance: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.CurrentUtilityAllowance',
    defaultMessage: 'Current Utility Allowance',
  },
  newUtilityAllowance: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.NewUtilityAllowance',
    defaultMessage: 'New Utility Allowance',
  },
  errorLoadingFloorPlans: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ErrorLoadingFloorPlans',
    defaultMessage: 'Error loading floor plans',
  },
  noHudFloorPlans: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.NoHudFloorPlans',
    defaultMessage: 'No HUD floor plans found for this property.',
  },
  confirmationPrompt: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ConfirmationPrompt',
    defaultMessage:
      'Are you sure you want to continue with adding these new Gross Rent limits as of {effectiveDate}?',
  },
  editConfirmationPrompt: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.EditConfirmationPrompt',
    defaultMessage:
      'Are you sure you want to continue with updating these Gross Rent limits as of {effectiveDate}?',
  },
  savingChangesTitle: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.SavingChangesTitle',
    defaultMessage: 'Saving these changes will:',
  },
  savingChangesUpdateAmounts: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.SavingChangesUpdateAmounts',
    defaultMessage:
      'Update Gross Rent and/or Utility Allowance amounts for floor plans displayed',
  },
  savingChangesCreateCertifications: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.SavingChangesCreateCertifications',
    defaultMessage:
      'Automatically create Gross Rent Certifications for impacted households',
  },
  editSavingChangesUpdateAmounts: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.EditSavingChangesUpdateAmounts',
    defaultMessage:
      'Update Gross Rent and/or Utility Allowance amounts for affected floor plans',
  },
  editSavingChangesUpdateCertifications: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.EditSavingChangesUpdateCertifications',
    defaultMessage:
      'Update the Gross Rent Certifications created for impacted households',
  },
  grossRentCertExistsWarning: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.GrossRentCertExistsWarning',
    defaultMessage:
      'Gross Rent Certifications have already been created for this year.',
  },
  errorCheckingGrossRentCertExists: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ErrorCheckingGrossRentCertExists',
    defaultMessage: 'Error checking gross rent certifications',
  },
  processingToastTitle: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ProcessingToastTitle',
    defaultMessage: 'In Progress',
  },
  processingToastMessage: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ProcessingToastMessage',
    defaultMessage: 'Saving GR Limits...',
  },
  successTitle: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.SuccessTitle',
    defaultMessage: 'Success',
  },
  successMessage: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.SuccessMessage',
    defaultMessage: 'New Gross Rent Limit added and Certifications created',
  },
  noCertificationsMessage: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.NoCertificationsMessage',
    defaultMessage:
      'New Gross Rent Limit added. No Certifications were created — review the impacted households.',
  },
  editSuccessMessage: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.EditSuccessMessage',
    defaultMessage: 'Gross Rent Limit updated',
  },
  errorSaving: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ErrorSaving',
    defaultMessage: 'Error saving gross rent limits',
  },
  errorNoChangesToSave: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ErrorNoChangesToSave',
    defaultMessage: 'No floor plan changes to save.',
  },
  required: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.Required',
    defaultMessage: 'Required',
  },
  mustBeGreaterThanZero: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.MustBeGreaterThanZero',
    defaultMessage: 'Value must be greater than 0.00',
  },
  errorLoadingAnticipatedVoucherMonth: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.ErrorLoadingAnticipatedVoucherMonth',
    defaultMessage: 'Error loading anticipated voucher month',
  },
  onboardedCertificationsAvdTooltip: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.OnboardedCertificationsAvdTooltip',
    defaultMessage:
      'Certifications for this change were loaded via baseline and this date cannot be modified.',
  },
  onboardedCertificationsEffectiveDateTooltip: {
    id: 'App.ManageGrossRents.AddGrossRentLimitsWizard.OnboardedCertificationsEffectiveDateTooltip',
    defaultMessage:
      'Certifications loaded for this Gross Rent Change match this Effective Date and it cannot be modified.',
  },
});
